import React from 'react';
import PlaceThumbnail from './place-thumbnail';
import ReadMore from './readmore';
import ItemExtras from './guide-components/item-extras';

var PlaceDetail = React.createClass({

  getPlaceDesc: function() {
    return {
      __html: !this.props.item.desc ? '' : this.props.item.desc
    };
  },
  
  render: function() {
    var item = this.props.item;  
    var rank = null; //<sup style={{ color: '#888', fontSize: 12 , marginLeft: 5 }}>{'(#' + item.rank + ')'}</sup>;
    var time = (this.props.weekday) ?  <time>{item.from} - {item.to}</time> : null;
    var markerPin = (this.props.groupIndex > 0) ? <div className={"marker-pin day_" + this.props.groupIndex }><span>{this.props.itemIndex}</span></div> : null;
    
    if (!!item.tags){ 
      var destinationName = item.destination.replace(/-/g, " "),
          tags = Array.isArray(item.tags) ? item.tags : item.tags.split(","),
          tagString = !!item.tags ? tags.filter(function(t){ return !(new RegExp(destinationName + "|Attraction|Dining", "gi").test(t)) }).join(", ") : null
    } else {
      var tagString = null;
    }

    var header = (this.props.isSmallScreen) ? null : (
        <header className="header clearfix">
          <div className="heading" style={{ width: 'auto'}}>
           {time}{rank}
            <h3>
                {markerPin}
                <a href={"/"+ item.destination +"/attraction/" + item.slug + '/' + item.id}>{item.name}</a>
            </h3>
            <p className='destination-tags'>{tagString}</p>
          </div>
        </header>
    );

    var windowWidth = $(window).width(),
        isMobile = windowWidth <= 768,
        isTablet = windowWidth > 768 && windowWidth <= 992,
        initialHeight = isMobile ? "80px" : (isTablet ? "80px" : "80px"), //Leaving this here in case we want to change it in the future
        wrapperClass = !item.photo && !this.props.autoImageUrls ? "col-sm-12" : "col-sm-8";
    
    return (
      <div className={ "place-detail " + wrapperClass }>
        <div className="holder">
          { header }          
          <PlaceThumbnail item={item} weekday={this.props.weekday} isSmallScreen={this.props.isSmallScreen} autoImageUrls={ this.props.autoImageUrls } groupIndex={this.props.groupIndex} itemIndex={this.props.itemIndex} />
          <ItemExtras item={ item } />
          {!!this.props.item.desc ? <ReadMore content={this.props.item.desc || this.props.item.long_desc} className="place-desc" initialHeight={ initialHeight } /> : "" }
        </div>
      </div>
    );
  }
});

module.exports = PlaceDetail;



// WEBPACK FOOTER //
// ./components/place-detail.js